import { createRef, Component } from 'react'
import * as styles from 'styles/pages/Styleguide.css'
import { Caption } from 'components/atoms/Text'
import { rgbToHex } from 'helpers/formatHelpers'

type ColorSwatchProps = {
  name: string
  style: string
}

type ColorSwatchState = {
  hexValue: string
  copied: boolean
}

class ColorSwatch extends Component<ColorSwatchProps, ColorSwatchState> {

  state = {
    hexValue: '',
    copied: false,
  }

  private swatchRef = createRef<HTMLDivElement>()
  private hexRef = createRef<HTMLInputElement>()

  render () {
    const { name, style } = this.props
    const { copied, hexValue } = this.state

    return (
      <div className={ styles.colorSwatch }>
        <figure ref={ this.swatchRef } className={ style } onClick={ this.copyColor }>
          { copied && <div className={ styles.copiedLabel }>Copied to clipboard</div> }
        </figure>
        <figcaption>
          <Caption text={ name } />
          <input
            ref={ this.hexRef }
            onClick={ this.copyColor }
            className={ styles.hex }
            value={ '#' + hexValue }
          />
        </figcaption>
      </div>
    )
  }

  componentDidMount () {
    const swatchNode = this.swatchRef.current
    if (!swatchNode) {
      return
    }

    const rgbColor = window.getComputedStyle(swatchNode, undefined).getPropertyValue('background-color')
    this.setState({ hexValue: rgbToHex(rgbColor) })
  }

  copyColor = () => {
    const hexNode = this.hexRef.current
    if (!hexNode) {
      return
    }

    hexNode.select()
    document.execCommand('copy')
    this.setState({ copied: true })
    setTimeout(() => this.setState({ copied: false }), 1500)
  }
}

const SGColors = () => (
  <section className={ styles.sgSection }>
    <h2 className={ styles.colorsHeading }>Brand Colors</h2>
    <div>
      <ColorSwatch name='oxford' style={ styles.oxford } />
      <ColorSwatch name='coral' style={ styles.coral } />
      <ColorSwatch name='merlot' style={ styles.merlot } />
    </div>
    <div>
      <ColorSwatch name='light oxford' style={ styles.lightOxford } />
      <ColorSwatch name='light coral' style={ styles.lightCoral } />
      <ColorSwatch name='light merlot' style={ styles.lightMerlot } />
    </div>

    <h2 className={ styles.colorsHeading }>Primary Colors</h2>
    <div>
      <ColorSwatch name='danger' style={ styles.danger } />
      <ColorSwatch name='warning' style={ styles.warning } />
      <ColorSwatch name='success' style={ styles.success } />
      <ColorSwatch name='action' style={ styles.action } />
    </div>
    <div>
      <ColorSwatch name='light danger' style={ styles.lightDanger } />
      <ColorSwatch name='light warning' style={ styles.lightWarning } />
      <ColorSwatch name='light success' style={ styles.lightSuccess } />
      <ColorSwatch name='light action' style={ styles.lightAction } />
    </div>

    <h2 className={ styles.colorsHeading }>Secondary Colors</h2>
    <div>
      <ColorSwatch name='shadow' style={ styles.shadow } />
      <ColorSwatch name='shade' style={ styles.shade } />
      <ColorSwatch name='slate' style={ styles.slate } />
      <ColorSwatch name='shale' style={ styles.shale } />
      <ColorSwatch name='stone' style={ styles.stone } />
      <ColorSwatch name='smoke' style={ styles.smoke } />
      <ColorSwatch name='storm' style={ styles.storm } />
      <ColorSwatch name='silver' style={ styles.silver } />
      <ColorSwatch name='satin' style={ styles.satin } />
      <ColorSwatch name='snow' style={ styles.snow } />
      <ColorSwatch name='salt' style={ styles.salt } />
    </div>
  </section>
)

export default SGColors
